// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"6":"fe3fafec","155":"c2546e90","318":"d88ed916"}[chunkId] || chunkId) + "-" + {"6":"a0cc1752ceb40ee9","7":"b29b74c9144e100b","33":"52c3c74f49a1c984","155":"df0106a5319d4d45","318":"a267d75e90181235"}[chunkId] + ".js";
};